import { getLocale } from 'umi';
import { getFilterCondStorage } from '../components/FilterCommon/utils/storage';
import { topicEnMap, topicZhMap } from '../constants';
import { DBO_V } from './format';

export function formatNewData(list: any[]) {
  if (list && Array.isArray(list)) {
    return list.map(item => ({
      ...item,
      name: item.key?.toLocaleLowerCase(),
      count: item.value,
    }));
  }

  return [];
}

/**
 * 获取 topic 缓存key
 * @param userInfo
 * @param gameInfo
 * @returns
 */
const getFilterTopicStorageKey = (gameInfo: { edition_unified_id: string }) => {
  const gameId = gameInfo.edition_unified_id;
  return `${gameId}-filter-topic`;
};

const getFilterTopicMap = (gameInfo: any) => {
  let key = getFilterTopicStorageKey(gameInfo);
  let sessionStorageMap = sessionStorage.getItem(key);
  if (sessionStorageMap) {
    return JSON.parse(sessionStorageMap);
  }
  let filterMap = getFilterCondStorage(gameInfo);
  if (filterMap) {
    let topicMap = { 'zh-CN': {}, 'en-US': {} };
    filterMap.topic_trans.forEach(
      ({ L1_topic, L1_topic_transl, topic_to_en, trans }: any) => {
        const key = (L1_topic as string).toLocaleLowerCase();
        const key1 = (topic_to_en as string).toLocaleLowerCase();
        topicMap['zh-CN'] = {
          ...topicMap['zh-CN'],
          [key]: topicZhMap[key] || L1_topic_transl,
          [key1]: topicZhMap[key1] || trans,
        };
        topicMap['en-US'] = {
          ...topicMap['en-US'],
          [key]: topicEnMap[key] || L1_topic,
          [key1]: topicEnMap[key1] || topic_to_en,
        };
      },
    );
    sessionStorage.setItem(key, JSON.stringify(topicMap));
    return topicMap;
  }

  return null;
};

export function transTopicName(topicName: string, gameInfo: any) {
  const allTopicMap = getFilterTopicMap(gameInfo);

  let topicMap = allTopicMap[getLocale()];
  const key = topicName?.toLocaleLowerCase();
  if (topicMap?.[key]) {
    return topicMap[key];
  }
  return topicName;
}

export function changePageLoading(dispatch: any) {
  const func = (value: boolean) =>
    dispatch({
      type: 'opinionCommon/save',
      payload: {
        pageLoading: value,
      },
    });

  func(true);

  setTimeout(() => {
    func(false);
  }, 500);
}

/**
 * 深度比较两个值是否相等，主要用于比较函数参数
 *
 * @param newValue 新的函数参数值，可以是任意类型
 * @param oldValue 旧的函数参数值，可以是任意类型
 * @returns 返回一个布尔值，表示两个参数是否相等
 */
export function compareParams(newValue: any, oldValue: any): boolean {
  // 处理边界条件
  if (
    newValue === null ||
    oldValue === null ||
    newValue === undefined ||
    oldValue === undefined
  ) {
    return newValue === oldValue;
  }

  // 确保两者都不是对象
  if (typeof newValue !== 'object' || typeof oldValue !== 'object') {
    return newValue === oldValue;
  }

  // 检查对象键的数量是否相同
  const newKeys = Object.keys(newValue);

  // 遍历新对象的所有键
  return newKeys.every(key => {
    const element = newValue[key];
    const oldElement = oldValue[key];

    // 检查旧对象是否包含该键
    if (!oldValue.hasOwnProperty(key)) {
      return false;
    }

    // 比较不同类型的数据
    if (
      typeof element === 'string' ||
      typeof element === 'number' ||
      typeof element === 'boolean'
    ) {
      return element === oldElement;
    }

    if (Array.isArray(element)) {
      return compareArraysEqual(element, oldElement);
    }

    if (typeof element === 'object' && element !== null) {
      return compareParams(element, oldElement);
    }

    return element === oldElement;
  });
}

// 实现 compareArraysEqual 函数
function compareArraysEqual(arr1: any[], arr2: any[]): boolean {
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
    return arr1 === arr2;
  }

  if (arr1.length !== arr2.length) {
    return false;
  }
  arr1.sort();
  arr2.sort();
  for (let i = 0; i < arr1.length; i++) {
    if (typeof arr1[i] === 'object' && arr1[i] !== null) {
      if (!compareParams(arr1[i], arr2[i])) {
        return false;
      }
    } else if (arr1[i] !== arr2[i]) {
      return false;
    }
  }

  return true;
}

export function dealwithSteamSelectedData(data: Array<any>) {
  if (data && Array.isArray(data) && data.length > 0) {
    let total = 0;
    let positive = 0;
    data.forEach((item: any) => {
      if (item.key === 'select_recommend') {
        total += item.review;
        positive += item.review;
      } else if (item.key === 'select_non_recommend') {
        total += item.review;
      }
    });
    const item = data.find(item => item.key === 'select_all_review'); 
    item.score = DBO_V.percentageValue(positive, total, 2); 
  }

  return data;
}
